/**
 * Small abstraction over Github Fetch.
 *
 * See github/fetch for documentation.
 * https://github.com/github/fetch
 */
import fetch from 'isomorphic-fetch';

/**
 * __API_HOST__ is a global variable injected by webpack.
 * It is
 * 'api.sourcesage.co' when in production mode,
 * 'kimchi.sourcesage.co' when in staging mode,
 *
 * Always use https!
 */
export const WebAPIBaseUrl = `${__API_HOST__}/api`;
export const LatestAPIVersion = '1.1';

/**
 * Modifies github `fetch` interface a bit, and add some defaults.
 *
 * Returns a github `fetch` Promise.
 */
function fetchAPI({
  endpoint,
  version = LatestAPIVersion,
  baseURL = WebAPIBaseUrl,
  absoluteURL,
  ...config
}) {
  return fetch(absoluteURL || `${baseURL}/v${version}${endpoint}`, config);
}

export default fetchAPI;



// WEBPACK FOOTER //
// ./app/utils/fetchAPI/index.js